module.exports = __webpack_public_path__ + "static/media/delete-icon.e303541b.svg";